import { IApplicationState } from '../../types/redux';

export const selectCurrentPage = (state: IApplicationState) => {
  return state.buildersProjects.data.page;
};
